/* eslint-disable */
export function getCurrentUrlParams(): Record<string, string> {
  if (!window.location.href.includes("?")) {
    return {};
  }
  const urlStr = window.location.href.split("?")[1];
  const obj: Record<string, string> = {};
  const paramsArr = urlStr.split("&");
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    const arr = paramsArr[i].split("=");
    obj[arr[0]] = arr[1];
  }
  return obj;
}

export function formatDate(inputDate: string) {
  const date = new Date(inputDate);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${month}-${day} ${hours}:${minutes}:${seconds}`;
}

declare const window: Window & {
  AndroidInterface: {
    getAppTheme: any, // 获取app主题
  },
  ClientInterface: {
    getDeviceCountryCode: any, // 获取设备国家码
  }
};

export const setTheme = () => {
  if (window.AndroidInterface?.getAppTheme) {
    const res = window.AndroidInterface.getAppTheme();
    if (res === "dark") {
      document.documentElement.dataset.theme = "dark";
    }
  }
};

export const getCountryCode = () => {
  if (window.ClientInterface?.getDeviceCountryCode) {
    const res = window.ClientInterface.getDeviceCountryCode();
    return res;
  }
}

export const getCookieValue = (name: string) => {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
